import { AppLink } from 'components/core/link/Link';
import { H5 } from 'components/core/text/Text';

import { Text } from '../../components/core/text';

const ErrorPage = () => {
  return (
    <div className="flex flex-col gap-4 p-8">
      <H5>Something went wrong.</H5>
      <Text>
        We&apos;re sorry about that. We&apos;ve alerted our team of the issue.
      </Text>
      <Text>
        In the meantime, try to go{' '}
        <AppLink className="text-primary" to="/" aria-label="click to refresh">
          <strong>the home page.</strong>
        </AppLink>{' '}
      </Text>
    </div>
  );
};

export default ErrorPage;
